<script setup>

import {ref, computed, useAttrs} from "vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import EditToggleButton from "../Pub/components/EditToggleButton.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();


const props = defineProps({
    modelValue: {
        type: [String, Number, Boolean, Object, Array],
        required: true,
    },
    customClasses: {
        type: [String, Array],
        default: ''
    },
});

const attrs = useAttrs();

const emit = defineEmits(['update:modelValue']);

const contentClasses = computed(() => [
    props.customClasses,
    attrs.class
]);

const isEditing = ref(false);
const hoverActive = ref(false);

const updateValue = (value) => emit('update:modelValue', value);

const toggleEdit = () => {
    isEditing.value = !isEditing.value
    if (!isEditing.value) {
        hoverActive.value = false
    }
}

</script>

<template>
    <div
        class="relative"
        @mouseenter="hoverActive = true"
        @mouseleave="hoverActive = false"
    >
        <edit-toggle-button
            v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
            :isEditing="isEditing"
            @toggle="toggleEdit"
            class="transition-opacity duration-200"
        />

        <div
            v-if="modelValue && !isEditing"
            :class="contentClasses"
            v-html="modelValue"
        />

        <text-editor
            v-else-if="isEditing"
            :text="modelValue"
            @input="updateValue"
        />
    </div>
</template>

